import React, { useState, useRef, useEffect } from 'react';
import { Spinner } from 'reactstrap';
import { FaPencilAlt, FaCheck, FaTimes } from 'react-icons/fa';

const EditableOrganizationName = ({ 
  organizationName, 
  organizationId, 
  updateOrganizationDetails, 
  isUpdating 
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState(organizationName || '');
  const inputRef = useRef(null);

  useEffect(() => {
    // Update the local name state when the prop changes
    setName(organizationName || '');
  }, [organizationName]);

  useEffect(() => {
    // Focus the input when entering edit mode
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  const handleStartEditing = () => {
    setIsEditing(true);
  };

  const handleSave = () => {
    if (name.trim() !== '' && name !== organizationName) {
      updateOrganizationDetails({
        id: organizationId,
        name: name.trim()
      });
    }
    setIsEditing(false);
  };

  const handleCancel = () => {
    setName(organizationName || '');
    setIsEditing(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
  };

  if (isEditing) {
    return (
      <div className="editable-org-name">
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={handleKeyDown}
          ref={inputRef}
          className="org-name-input"
          disabled={isUpdating}
          maxLength={50}
        />
        {isUpdating ? (
          <Spinner size="sm" color="primary" className="ml-2" />
        ) : (
          <button
            className="edit-icon save"
            onClick={handleSave}
            disabled={name.trim() === '' || name === organizationName}
            title="Save organization name"
          >
            <FaCheck />
          </button>
        )}
        <button
          className="edit-icon cancel"
          onClick={handleCancel}
          disabled={isUpdating}
          title="Cancel editing"
        >
          <FaTimes />
        </button>
      </div>
    );
  }

  return (
    <div className="editable-org-name">
      <h1>{organizationName}</h1>
      <button 
        className="edit-icon" 
        onClick={handleStartEditing}
        title="Edit organization name"
      >
        <FaPencilAlt />
      </button>
    </div>
  );
};

export default EditableOrganizationName; 